import { render, staticRenderFns } from "./ArcadeDetail.vue?vue&type=template&id=efc70d0e&scoped=true&"
import script from "./ArcadeDetail.vue?vue&type=script&lang=js&"
export * from "./ArcadeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArcadeDetail.vue?vue&type=style&index=0&id=efc70d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc70d0e",
  null
  
)

export default component.exports